import { clientPrototypeConfig } from "./deepmox/clientPrototypeConfig";
import { domainRuntimeConfig } from "./deepmox/domainConfig";
import { serverConfig } from "./deepmox/serverConfig";

export const deepmoxConfig = {
  server: serverConfig,
  domain: domainRuntimeConfig,
  clientPrototype: clientPrototypeConfig,
} as const;
